import { SVGProps } from 'react';

export const ClosedLockIcon = (props: SVGProps<SVGSVGElement>) => {
	const color = props.color ?? '#BEBEBE';
	const style = props.style;
	const width = props.width ?? '15';
	const height = props.height ?? '22';
	return (
		<svg width={width} height={height} viewBox='0 0 14 22' fill='none' xmlns='http://www.w3.org/2000/svg' style={style}>
			<path
				d='M13.2855 16.843V11.4414C13.2854 11.1484 13.2089 10.8605 13.0637 10.6068C12.9184 10.353 12.7096 10.1424 12.4582 9.99602L7.8257 7.29475C7.57442 7.14836 7.28943 7.07129 6.99933 7.07129C6.70923 7.07129 6.42424 7.14836 6.17295 7.29475L1.54049 9.99602C1.28918 10.1424 1.08049 10.3531 0.935421 10.6069C0.790353 10.8606 0.714022 11.1484 0.714111 11.4414V16.843C0.714049 17.1361 0.790382 17.4241 0.935439 17.678C1.0805 17.9319 1.28917 18.1428 1.54049 18.2894L6.17693 20.9907C6.42821 21.1371 6.7132 21.2141 7.0033 21.2141C7.2934 21.2141 7.57839 21.1371 7.82968 20.9907L12.4621 18.2894C12.7128 18.1423 12.9209 17.9313 13.0654 17.6774C13.2099 17.4235 13.2858 17.1358 13.2855 16.843Z'
				stroke={color}
				strokeWidth='1.375'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7.90373 15.206C8.4559 14.8909 8.82813 14.2967 8.82813 13.6155C8.82813 12.6049 8.00888 11.7856 6.99829 11.7856C5.9877 11.7856 5.16846 12.6049 5.16846 13.6155C5.16846 14.2964 5.54036 14.8904 6.09211 15.2055L5.23609 16.5844C5.19487 16.6509 5.17214 16.7273 5.17026 16.8056C5.16838 16.8839 5.18741 16.9612 5.22538 17.0297C5.26336 17.0982 5.31891 17.1553 5.38631 17.1951C5.45371 17.235 5.53051 17.2561 5.60881 17.2564H8.3856C8.464 17.2564 8.54095 17.2353 8.60852 17.1956C8.67608 17.1558 8.73179 17.0987 8.76991 17.0302C8.80802 16.9617 8.82715 16.8842 8.82532 16.8059C8.82349 16.7275 8.80076 16.651 8.75949 16.5844L7.90373 15.206Z'
				fill={color}
			/>
			<path
				d='M10.9286 9.42843V5.49986C10.9286 3.33017 9.16967 1.57129 6.99998 1.57129V1.57129C4.83029 1.57129 3.07141 3.33017 3.07141 5.49986V9.42843'
				stroke={color}
				strokeWidth='1.375'
			/>
		</svg>
	);
};
